import { Injectable, Inject } from "@angular/core";
import { Observable } from "rxjs";
import { switchMap } from "rxjs/operators";
import { Constants } from "../models/constants.model";
import { BaseClient } from "./base-client.service";
import { NbAuthService, NbAuthToken } from "@nebular/auth";
export class AppointmentAnalyticsResponse {
  chart: AppointmentChart;
  summary: AppointmentSummary[];
}

export class AppointmentChart {
  chartLabel: string[];
  linesData: number[][];
}

export class AppointmentSummary {
  title: string;
  value: number;
}

export class UserAnalyticsResponse {
  chart: UserChart;
  summary: UserSummary[];
}

export class UserChart {
  chartLabel: string[];
  linesData: number[][];
}

export class UserSummary {
  title: string;
  value: number;
}

export class UserStatisticsResponse {
  total: number;
  customers: number;
  stores: number;
}

export class CategorySummaryResponse {
  summary: CategorySummary[];
}

export class CategorySummary {
  total: number;
  primary_category_id: string;
}

export class DailyActiveChart {
  weeks: string[];
  count: number[];
}

export class TrafficList {
  date: string;
  value: number;
  delta: {
    up: boolean;
    value: number;
  };
  comparison: {
    prevDate: string;
    prevValue: number;
    nextDate: string;
    nextValue: number;
  };
}

@Injectable({
  providedIn: "root",
})
export class DashboardClient extends BaseClient {
  public static readonly BASE_ENDPOINT = Constants.API_BASE_URL + "/dashboard";

  public appointmentAnalytics(): Observable<AppointmentAnalyticsResponse> {
    return this.authService.getToken().pipe(
      switchMap((token) => {
        return this.http.get<AppointmentAnalyticsResponse>(
          DashboardClient.BASE_ENDPOINT + "/appointment-analytics",
          { headers: this.getHeaders(token) }
        );
      })
    );
  }

  public userAnalytics(): Observable<UserAnalyticsResponse> {
    return this.authService.getToken().pipe(
      switchMap((token) => {
        return this.http.get<UserAnalyticsResponse>(
          DashboardClient.BASE_ENDPOINT + "/user-analytics",
          { headers: this.getHeaders(token) }
        );
      })
    );
  }

  public categorySummary(): Observable<CategorySummaryResponse> {
    return this.authService.getToken().pipe(
      switchMap((token) => {
        return this.http.get<CategorySummaryResponse>(
          DashboardClient.BASE_ENDPOINT + "/category-summary",
          { headers: this.getHeaders(token) }
        );
      })
    );
  }

  public dailyActiveAnalytics(): Observable<DailyActiveChart> {
    return this.authService.getToken().pipe(
      switchMap((token) => {
        return this.http.get<DailyActiveChart>(
          DashboardClient.BASE_ENDPOINT + "/daily-active-analytics",
          { headers: this.getHeaders(token) }
        );
      })
    );
  }
  public getBannerCounts(): Observable<any> {
    return this.authService.getToken().pipe(
      switchMap((token) => {
        return this.http.get<any>(Constants.API_BASE_URL + "/api/banner/getBannerCounts", {
          headers: this.getHeaders(token),
        });
      })
    );
  }

    public getRating(): Observable<any> {
    return this.authService.getToken().pipe(
      switchMap((token) => {
        return this.http.get<any>(Constants.API_BASE_URL + "/api/rating", {
          headers: this.getHeaders(token),
        });
      })
    );
  }

    public getGraph(): Observable<any> {
    return this.authService.getToken().pipe(
      switchMap((token) => {
        return this.http.get<any>(Constants.API_BASE_URL + "/api/bannerclick/graph", {
          headers: this.getHeaders(token),
        });
      })
    );
  }
}
